import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import trackingService from "../../services/trackingService";

const PageTracker = () => {
  const location = useLocation();
  useEffect(() => {
    trackingService.trackPage(location.pathname);
  }, [location.pathname]);

  return null;
};

export default PageTracker;
